export default __webpack_public_path__ + "static/testimonial-user-3-b3f83f454e94b9e004854dfc3fac3857.jpg";